export default __webpack_public_path__ + "static/media/avatarD4.ba7ef54a.png";